export const formatPrice = (price: string) => {
  if (!price) return "";
  
  const splitPrice = price.split(".");
  let formattedPrice = splitPrice[1] ? `.${splitPrice[1]}` : "";
  
  const length = splitPrice[0].length - 1;
  for (let i = 0; i < length + 1; i++) {
    if (i%3 === 0 && i!==0) formattedPrice = ","+formattedPrice;
    formattedPrice = splitPrice[0][length - i] + formattedPrice;
  }

  return formattedPrice;
}